module.exports = __webpack_public_path__ + "static/mo17-6f4c4ab85e43108f56f5cfcdfbc320b2.png";